import { render, staticRenderFns } from "./CoRules.vue?vue&type=template&id=3d9d5b06&scoped=true&"
import script from "./CoRules.vue?vue&type=script&lang=ts&"
export * from "./CoRules.vue?vue&type=script&lang=ts&"
import style0 from "./CoRules.vue?vue&type=style&index=0&id=3d9d5b06&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9d5b06",
  null
  
)

export default component.exports